import SignInComponent from '../../../../Components/AdminComponents/Auth/SignIn';

const SignInContainer = () => {
  return <SignInComponent />;
};
export default SignInContainer;
